import React from 'react';

const IconHackerrank = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 630.117 630.117">
  <title>Hackerrank</title>
<path d="M580.529,165.226C562.556,134.278,341.907,6.45,305.981,6.45c-35.922,0-256.662,127.509-274.538,158.775
  c-17.877,31.271-17.972,286.291-0.003,317.557C49.415,514.047,270.077,641.55,305.981,641.55s256.584-127.664,274.544-158.771
  C598.484,451.67,598.498,196.174,580.529,165.226z M380.366,520.256c-4.916,0-50.74-44.372-47.136-47.993
  c1.081-1.082,7.77-1.842,21.77-2.273v-1.198c0-27.956,0.646-79.77,1.16-105.877c0.052-2.51-0.55-4.251-0.55-7.251
  c-33.316,0-65.843,0-99.146,0c0,12-0.211,24.915,0.044,37.634c0.332,16.795,0.814,35.986,1.651,52.764
  c0.28,5.635-1.956,7.396-7.124,7.374c-12.57-0.035-25.148-0.139-37.726-0.104c-5.085,0.015-7.277-1.893-7.121-7.573
  c0.955-34.525,1.963-71.89,1.926-106.424C208.075,298.029,207,223.256,206,181.951v-3.929c-12-0.433-20.324-1.194-21.411-2.287
  c-3.622-3.618,42.846-47.989,47.742-47.989c4.906,0,51.073,44.382,47.47,47.989c-1.083,1.084-9.801,1.844-20.801,2.278v3.925
  c-3,31.937-2.52,98.725-3.262,130.725c33.72,0,66.259,0,99.555,0c0-13,0.163-25.011-0.031-37.038
  c-0.341-21.233-0.771-45.488-1.46-66.717c-0.13-4.205,1.176-6.413,5.224-6.447c13.734-0.096,27.477-0.157,41.217-0.069
  c4.297,0.021,5.674,2.136,5.58,6.679c-0.908,47.6-2.284,97.997-2.429,145.608C403.306,383.333,404,437.89,405,468.257v1.72
  c11,0.432,20.86,1.195,21.946,2.286C430.552,475.884,385.275,520.256,380.366,520.256z"/>
</svg>
);

export default IconHackerrank;
